<br>
<div class="allocation-summary" *ngIf="hasTimeline">
  <div class="header">
    <h3 class="header__title">Allocation Summary</h3>
  </div>
  <div class="allocation-summary__table">
    <div class="allocation-summary__header">Project Information</div>

    <div class="allocation-summary__row">
      <span class="allocation-summary__label">Project Timeline:</span>
      <span class="allocation-summary__value">Start date {{ startDate | date:'MM/dd/yyyy' }} - End date {{ endDate | date:'MM/dd/yyyy' }}</span>
    </div>

    <div class="allocation-summary__row" *ngIf="hasLastLoad">
      <span class="allocation-summary__label">Last Data load:</span>
      <span class="allocation-summary__value">
        {{ projectLastLoadDate | date:'MM/dd/yyyy h:mma' }} ({{ projectLastLoadUser }})
      </span>
    </div>
  </div>
</div>